module.exports = __webpack_public_path__ + "img/mlbb.20d3c0b.png";